import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const scanPackage = createAction(ACTION.SCAN_PACKAGE.REQUEST);
export const scanTrackingBill = createAction(ACTION.SCAN_TRACKING_BILL.REQUEST);
